import {
  useTenantNavigate,
  openWithTenant,
  buildProgramServiceHeaders,
  EntityFieldRelationshipType,
} from '@app-store'
import {
  Assigned,
  columnTypesConst,
  ConfirmDialog,
  MODE_CONSTANTS,
  Pagination,
  ShowEditableIcon,
  // ShowReviewIcon,
  SORT_KEYS,
  TableActionType,
  TableColumnType,
  Unassigned,
} from '@ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { checkQueType, permissionObject } from '../../utils/helperFunctions'
import {
  addToaster,
  AgentType,
  API_END_POINT,
  axiosInstance,
  DataType,
  DataTypeStore,
  ErrorResponseData,
  fetchCommunicationIdCorrespondingData,
  getOptionsOnFocus,
  hideLoader,
  LayoutElementType,
  LayoutResponseType,
  parseNumericId,
  queueListingType,
  SearchCriteria,
  showLoader,
  TableFilterObjectBody,
  updateNumOfRows,
} from '@app-store'
import { ElementType, EntityLayout } from '../../types/layout.types'
import {
  COMM_TEMPLATE,
  componentNames,
  DASHBOARD,
  EMPTY_TABLE_DATA_MESSAGE,
  ENTITY_ID,
  ENTITY_NAME,
  FIELD_VALUE_CONSTANTS,
  HTTP_STATUS_CONSTANTS,
  INTAKE_QUEUE,
  NAMESPACES,
  PAGINATION,
  PERMISSION_ACCESSIBILITY,
  PERMISSION_MODULES,
  RECORD_STATE,
  REPORTS,
  TABLE_HEADER_KEYS_ARRAY,
  USER_PROFILES,
} from '../../utils/constants'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { DynamicQueuesType, QueueCriterum } from '../../types/queueConfig.types'
import { isEmpty, isNull, noop, uniqueId } from 'lodash'
import {
  DYNAMIC_QUEUE_CONSTANTS,
  DYNAMIC_QUEUE_MESSAGES,
} from '../../constants/dynamicQueue'
import {
  assignCasesWithAgent,
  editEntityDataEmbeddedAPI,
  postValidateCasesWithAgent,
  unassignCasesWithAgent,
} from '../../apis/entityData.api'
import { v4 as uuid } from 'uuid'
import PersistTable from '../../common/PersistTable'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import { AxiosError, AxiosResponse } from 'axios'
import { isReadOnlyUser, isSuperAdmin } from '../../utils/permission'
import { handleOpenLink } from '../../utils/dynamic-queue'
import {
  getMigratedLayoutId,
  getMigrationStatus,
} from '../../utils/migration.utils'
import {
  FilterCriteriaForQueue,
  RelatedEntitiesForQueue,
} from '../../types/types'
import {
  buildFilterData,
  checkFilterColumn,
  removeColumns,
  getWebEnrollmentStatusFilterOptions,
  clearWebEnrollmentStatusCache,
} from '../../utils/listing.utils'
import { getElementFromAddedFields } from '../../utils/form.utils'
import MultiUploadWrapper from '../../components/MultiUploadWrapper'
import { FaxDocumentModal } from '../../components/intake-queue/FaxDocumentModal'
import { WEB_PREVIEW } from '../../constants/intakeQue.constants'
import { getMultiLookUpForListingTable } from '../../components/listing-table/ListingTableHelperComponents'
import {
  captureInitialIntakeStatus,
  getEnrollmentStatusFromQueueRow,
} from '../../utils/multiProductEnrollment.utils'
import { STRINGS } from '../../utils/strings'

export const QueueTable = ({
  queueData,
  entityData,
  listingLayout,
  fetchEntityData,
  totalPages,
  rowsPerPage,
  totalElements,
  numberOfElements,
  setEntityData,
  setSelectedRows,
  selectedRows,
  sendPageDataToDynamicQueue,
  sendFilterDataFromChild,
  setHeaderValues,
  headerValues,
  sortDirection,
  setSortDirection,
  entityName,
  isCaseWorkBasket,
  isTaskWorkBasket,
  queueType,
  queueFilterCriteria = [],
  queueFilterRealtedEntities,
  apiFilter,
  setApiFilter,
  isMounted,
  isDashboard,
  refetchKeyFromDashboard,
  setCompleteSelectedRows,
  dashboardListName,
  handleAssignUnassignForDashboard,
  caseEntityId: caseEntityIdProp,
}: {
  queueData: DynamicQueuesType | undefined
  entityData: DataTypeStore[]
  listingLayout: EntityLayout | undefined
  fetchEntityData: (
    apiFilter?: TableFilterObjectBody,
    rowsPerPage?: number,
    currentPage?: number,
    resetPage?: boolean,
    sortDirection?: {
      keyName: string
      direction: SORT_KEYS
      isAsc: SORT_KEYS
      key: string
    }
  ) => Promise<void>
  totalPages: number
  rowsPerPage: number
  totalElements?: number
  numberOfElements?: number
  entityName?: string
  setEntityData: React.Dispatch<React.SetStateAction<DataTypeStore[]>>
  setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>
  selectedRows: string[]
  sendPageDataToDynamicQueue: (data: number) => void
  sendFilterDataFromChild: (data: TableFilterObjectBody) => void
  // showTableType?: string   {/* TODO will review later */}
  setHeaderValues: React.Dispatch<React.SetStateAction<DataTypeStore>>
  headerValues: DataTypeStore
  sortDirection: {
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  }
  setSortDirection: React.Dispatch<
    React.SetStateAction<{
      keyName: string
      direction: SORT_KEYS
      isAsc: SORT_KEYS
      key: string
    }>
  >
  isCaseWorkBasket?: boolean
  isTaskWorkBasket?: boolean
  queueType: string
  queueFilterCriteria?: FilterCriteriaForQueue[]
  queueFilterRealtedEntities?: RelatedEntitiesForQueue
  apiFilter: TableFilterObjectBody | undefined
  setApiFilter: React.Dispatch<
    React.SetStateAction<TableFilterObjectBody | undefined>
  >
  isMounted: React.MutableRefObject<boolean>
  isDashboard: boolean
  refetchKeyFromDashboard: number
  setCompleteSelectedRows: React.Dispatch<React.SetStateAction<DataType[]>>
  dashboardListName: string
  handleAssignUnassignForDashboard?: (
    agent: AgentType | null,
    rows: DataType[]
  ) => Promise<AxiosResponse | undefined> | undefined
  caseEntityId?: number
}) => {
  const selectedTenant = useAppSelector(
    (state: RootState) => state?.authUser?.selectedClientTenant
  )
  const numOfPage = useAppSelector((state) => state?.pagination.numOfRows)
  const siteSettings = useAppSelector((state) => state?.authUser?.site_settings)

  const authUser = useAppSelector((state: RootState) => state?.authUser)
  const isDemoDashboardChanges =
    (
      authUser?.site_settings?.find(
        (v) => v?.key === STRINGS.DEMO_DASHBOARD_CHANGES
      )?.value as string
    )?.toLowerCase() === 'true'
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const queueConfigData = useAppSelector(
    (state: RootState) => state?.queueCreation?.children
  )
  const enabledQueues = queueConfigData.filter(
    (item: queueListingType) => item?.enabled
  )
  const faxQueue = enabledQueues.filter(
    (item: queueListingType) => item?.name === REPORTS.FAX
  )
  const mailQueue = enabledQueues.filter(
    (item: queueListingType) => item?.name === INTAKE_QUEUE.MAIL
  )
  const webQueue = enabledQueues.filter(
    (item: queueListingType) => item?.name === REPORTS.WEB
  )
  const userId = useAppSelector((state: RootState) => state.authUser.user?.id)
  // TODO: removed id from here to prevent unneccesorry rendering from useeffect below
  const entityid = queueData?.entity_id
  const layoutid = queueData?.layout_id
  const id = queueData?.id
  const getWebQueueDetailsModalTitle = (row: DataTypeStore) => {
    const enrollmentId = row?.[QUEUE_STRINGS.ENROLLMENT_ID]?.toString() || '--'
    return (
      <>
        <span className="text-sm">{enrollmentId}</span>
        <span className="mx-1 text-sm">/</span>
        <span className="text-[18px] text-primary-500">
          {NAMESPACES.VIEW_DETAILS}
        </span>
      </>
    )
  }

  const genericQueueActions: TableActionType<DataTypeStore>[] = [
    {
      label: NAMESPACES.EDIT,
      key: NAMESPACES.EDIT_KEY,
      showInPopUp: false,
    },
  ]
  const [modal, setModal] = useState<{
    type: string
    state: boolean
    index: number
    row?: DataType
  }>({
    type: '',
    state: false,
    index: -1,
  })
  const [emptyDataMessage, setEmptyDataMessage] = useState<string>('')
  const isDiscarded = (row: DataTypeStore | undefined | null) => {
    return !!(
      (row?.category_status &&
        row['category_status.label']?.toString()?.toLowerCase() ===
          DYNAMIC_QUEUE_CONSTANTS.DISCARDED_LOWERCASE) ||
      (row?.category_status &&
        row['category_status.label']?.toString()?.toLowerCase() ===
          DYNAMIC_QUEUE_CONSTANTS.FAILED_LOWERCASE) ||
      (row?.enrollment_status &&
        row['enrollment_status.label']?.toString()?.toLowerCase() ===
          DYNAMIC_QUEUE_CONSTANTS.DISCARDED_LOWERCASE) ||
      (row?.enrollment_status &&
        row['enrollment_status.label']?.toString()?.toLowerCase() ===
          DYNAMIC_QUEUE_CONSTANTS.FAILED_LOWERCASE) ||
      (row?.enrollment_status &&
        row['enrollment_status.label'] === DYNAMIC_QUEUE_CONSTANTS.COMPLETED) ||
      (row?.category_status &&
        row['category_status.label'] === DYNAMIC_QUEUE_CONSTANTS.COMPLETED)
    )
  }
  const enrollmentStatusCacheRef = useRef<string[] | null>(null)
  const handleUnssignedClick = async (rowId: number, row?: DataType) => {
    try {
      const agentId = authUser?.user
      const agent = {
        label: `${agentId?.first_name} ${agentId?.last_name} | ${agentId?.user_id}`,
        value: agentId?.user_id ?? '',
        id: agentId?.id ?? 0,
        status: DYNAMIC_QUEUE_CONSTANTS.UNAVAILABLE,
      }
      setModal({ type: '', state: false, index: -1 })
      dispatch(showLoader())
      let response
      if (
        isDashboard &&
        (dashboardListName === ENTITY_NAME.CASE ||
          dashboardListName === QUEUE_STRINGS.INTAKE) &&
        row &&
        handleAssignUnassignForDashboard
      ) {
        response = await handleAssignUnassignForDashboard(null, [row])
      } else {
        response = await unassignCasesWithAgent(
          [rowId.toString()] as string[],
          agent,
          layoutid?.toString(),
          entityid?.toString(),
          entityName
        )
      }
      if (response) {
        dispatch(
          addToaster({
            id: uuid(),
            message: DYNAMIC_QUEUE_MESSAGES.UNASSIGNED_SUCCESSFULLY,
            type: 'success',
          })
        )
        setSelectedRows([])
        setCompleteSelectedRows([])
        setHeaderValues({ selected: false })
      }
      await fetchEntityData(apiFilter, rowsPerPage, currentPage - 1)
      if (
        isDashboard &&
        dashboardListName === DASHBOARD.DOCUMENT &&
        handleAssignUnassignForDashboard
      ) {
        await handleAssignUnassignForDashboard(null, [])
      }
    } catch (error) {
      dispatch(
        addToaster({
          id: uuid(),
          message: DYNAMIC_QUEUE_MESSAGES.ERROR_WHILE_UNASSIGNING,
          type: 'error',
        })
      )
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  type AssignableId =
    | string
    | number
    | boolean
    | string[]
    | number[]
    | undefined

  const assignQueueToReviewerFunction = async (
    id: number | string,
    communication_id: AssignableId,
    caseId?: string | number | boolean | string[] | number[],
    showToaster = true,
    selectedRow?: DataType | null | undefined
  ) => {
    await assignQueueToReviewer(
      id,
      authUser?.user?.id,
      communication_id,
      caseId ?? '',
      showToaster,
      selectedRow
    )
  }

  const assignQueueToReviewer = async (
    communicationId: AssignableId,
    userId: AssignableId,
    faxId: AssignableId,
    caseId: string | number | boolean | string[] | number[],
    showToaster: boolean,
    selectedRow?: DataType | null | undefined
  ) => {
    const isHcpPortal =
      queueData?.entity_name?.toLowerCase() === ENTITY_NAME.HCP_PORTAL_ENTITY
    let webReviewPath
    // const communicationIdStr = communicationId?.toString() ?? ''
    if (
      isHcpPortal ||
      (isDashboard &&
        selectedRow?.['category_communication_type.label'] !== REPORTS.FAX &&
        selectedRow?.['category_communication_type.label'] !==
          INTAKE_QUEUE.MAIL)
    ) {
      if (isDashboard && dashboardListName === DASHBOARD.INTAKE) {
        await assignCasetoAgentFunctionWeb(
          selectedRow?.id?.toString() ?? '',
          undefined,
          selectedRow
        )
        await fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
        webReviewPath = `/manage-queue/dynamic-queue/${webQueue[0]?.entity_id}/${webQueue[0]?.layout_id}/${webQueue[0]?.id}/${communicationId}/${caseEntityId}/hcp`
        navigateWebQueue(webReviewPath, selectedRow)
      } else {
        webReviewPath = `/manage-queue/dynamic-queue/${entityid}/${layoutid}/${id}/${communicationId}/${caseEntityId}/hcp`
      }
      if (entityid) navigateWebQueue(webReviewPath, selectedRow)
      return
    }
    try {
      const programId = selectedRow?.['programs.id']?.toString()
      const response = await axiosInstance.patch(
        `${API_END_POINT.DELIVERY}/v1/communications/assign/${communicationId}/${userId}`,
        {},
        {
          headers: buildProgramServiceHeaders(programId),
        }
      )
      const isLegacyFax = faxId?.toString().startsWith('L')
      if (response?.status === HTTP_STATUS_CONSTANTS.SUCCESS) {
        await fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
        if (showToaster) {
          dispatch(
            addToaster({
              message: isLegacyFax
                ? `${NAMESPACES.LETTER_ASSIGNED_MESSAGE} ${faxId}`
                : `${NAMESPACES.CASE_ASSIGNED_MESSAGE} ${faxId}`,
              type: 'success',
              id: uuid(),
            })
          )
        }
      }

      if (caseId && isLegacyFax) {
        const casePath = `/entity/${
          isLegacyFax ? caseEntityId : entityid
        }/workflow/review/${caseId}?communicationId=${communicationId}`
        navigate(casePath)
      } else if (caseEntityId) {
        let faxReviewPath
        if (isDashboard && dashboardListName === DASHBOARD.INTAKE) {
          if (
            selectedRow?.['category_communication_type.label'] === REPORTS.FAX
          ) {
            faxReviewPath = `/manage-queue/dynamic-queue/${faxQueue[0]?.entity_id}/${faxQueue[0]?.layout_id}/${faxQueue[0]?.id}/${communicationId}/${caseEntityId}`
          } else {
            faxReviewPath = `/manage-queue/dynamic-queue/${mailQueue[0]?.entity_id}/${mailQueue[0]?.layout_id}/${mailQueue[0]?.id}/${communicationId}/${caseEntityId}`
          }
        } else {
          faxReviewPath = `/manage-queue/dynamic-queue/${entityid}/${layoutid}/${id}/${communicationId}/${caseEntityId}`
        }
        navigate(faxReviewPath)
      }
    } catch (error) {
      console.error(error)
      const errorMessage =
        (error as AxiosError<ErrorResponseData>).response?.data?.message ??
        DYNAMIC_QUEUE_MESSAGES.CASE_ALREADY_ASSIGNED
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    }
  }

  // need to check with dev later
  // const unAssignQueueToReviewer = async (
  //   communicationId:
  //     | string
  //     | number
  //     | boolean
  //     | string[]
  //     | number[]
  //     | undefined,
  //   _faxId: string | number | boolean | string[] | number[]
  // ) => {
  //   try {
  //     const response = await axiosInstance.patch(
  //       `${API_END_POINT.DELIVERY}/v1/communications/unassign/${communicationId}`
  //     )

  //     if (response.status === HTTP_STATUS_CONSTANTS.SUCCESS) {
  //       await fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
  //       dispatch(
  //         addToaster({
  //           message: `${DYNAMIC_QUEUE_MESSAGES.UNASSIGNED_SUCCESSFULLY}`,
  //           type: 'success',
  //           id: uuid(),
  //         })
  //       )
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const handleEditClickForCase = (row: DataType | null) => {
    if (caseEntityId && entityid) {
      if (isTaskWorkBasket) {
        openNewWindow(
          `/entity/${caseEntityId}/workflow/review/${row?.case_primary_id}`
        )
      } else {
        openNewWindow(`/entity/${entityid}/workflow/review/${row?.id}`)
      }
    } else if (isDashboard && dashboardListName === ENTITY_NAME.CASE) {
      openNewWindow(`/entity/32/workflow/review/${row?.id}`)
    } else if (dashboardListName === DASHBOARD.MY_TASK) {
      openNewWindow(
        `/entity/${caseEntityId}/workflow/review/${row?.case_primary_id}`
      )
    }
  }

  const genericQueueActionsForCase: TableActionType<DataTypeStore>[] = [
    {
      label: NAMESPACES.EDIT,
      key: NAMESPACES.EDIT_KEY,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (
          row?.users ||
          isCaseWorkBasket ||
          isTaskWorkBasket ||
          dashboardListName === DASHBOARD.MY_TASK
        ) {
          return (
            <ShowEditableIcon
              handleClick={() => handleEditClickForCase(row)}
              isDisabled={
                isCaseWorkBasket || isTaskWorkBasket
                  ? !!(
                      (authUser?.user?.profile ===
                        USER_PROFILES.STANDARD_USER ||
                        authUser?.user?.profile === USER_PROFILES.SUPPORT) &&
                      (!!row?.disabled ||
                        (row &&
                          row['user_id'] !== authUser.user?.id &&
                          row['users.id'] !== authUser.user?.id))
                    )
                  : (authUser?.user?.profile === USER_PROFILES.STANDARD_USER ||
                      authUser?.user?.profile === USER_PROFILES.SUPPORT) &&
                    (!!row?.disabled ||
                      row?.['users.id'] !== authUser.user?.id ||
                      !permissionObject.Queue_Review_Manage(
                        programPermissions,
                        row?.['programs.id']?.toString() ?? '',
                        row?.['services.service_name']?.toString() ?? ''
                      ))
              }
              key={uniqueId()}
            />
          )
        } else return null
      },
    },
    {
      label: DYNAMIC_QUEUE_CONSTANTS.UNASSIGNED,
      key: DYNAMIC_QUEUE_CONSTANTS.UNASSIGNED,
      showInPopUp: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) =>
        row?.users && !(isCaseWorkBasket || isTaskWorkBasket) ? (
          <Unassigned
            handleClick={() =>
              setModal({
                type: DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_UNASSIGN_MESSAGE,
                state: true,
                index: Number(row?.id),
                row: row,
              })
            }
            isDisabled={
              (row['users.id'] !== authUser.user?.id ||
                !permissionObject.Queue_Case_Reassignment(
                  programPermissions,
                  row['programs.id']?.toString(),
                  row['services.service_name']?.toString()
                )) &&
              !permissionObject.Queue_Bulk_Assignment_Permission(
                programPermissions,
                PERMISSION_MODULES.BULK_WORK_ASSIGNMENTS,
                PERMISSION_ACCESSIBILITY.MANAGE,
                row['programs.id']?.toString()
              )
            }
            key={uniqueId()}
          />
        ) : null,
    },
    {
      label: DYNAMIC_QUEUE_CONSTANTS.ASSIGNED,
      key: DYNAMIC_QUEUE_CONSTANTS.ASSIGNED,
      showInPopUp: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (
          row &&
          !row?.users &&
          !(isCaseWorkBasket || isTaskWorkBasket) &&
          !(dashboardListName === DASHBOARD.MY_TASK)
        ) {
          return (
            <Assigned
              handleClick={async () => {
                await assignCasetoAgentFunction(
                  row?.id?.toString() ?? '',
                  row,
                  row?.case_key?.toString() ?? ''
                )
                // TODO: might need later openNewWindow(`/entity/${entityid}/workflow/review/${row?.id}`)
              }}
              isDisabled={
                !permissionObject.Queue_Case_Assignment(
                  programPermissions,
                  row['programs.id']?.toString(),
                  row['services.service_name']?.toString()
                )
              }
              key={uniqueId()}
            />
          )
        } else return null
      },
    },
  ]

  // const migrationQueueActionsForCase: TableActionType<DataTypeStore>[] = [
  //   {
  //     label: NAMESPACES.VIEW,
  //     key: NAMESPACES.VIEW_KEY,
  //     showInPopUp: false,
  //     isEnabledOnDisabledRow: false,
  //     type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
  //     renderActionComponent: (row: DataType | null) => {
  //       if (row) {
  //         return (
  //           <ShowReviewIcon
  //             handleClick={async () => {
  //               const layoutId = await getMigratedLayoutId()
  //               navigate(`/entities/32/tab/${row?.id}?layoutId=${layoutId}`)
  //             }}
  //           />
  //         )
  //       } else return null
  //     },
  //   },
  // ]

  const actions: TableActionType<DataTypeStore>[] = [
    {
      label: NAMESPACES.EDIT,
      key: NAMESPACES.EDIT_KEY,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (
          row?.disabled ||
          (row?.users && !row?.disabled) ||
          row?.['assignee.id']
        ) {
          const hasIntakePermission =
            permissionObject.Queue_Review_Manage_Intake(
              programPermissions,
              checkQueType(queueData) !== 'Letter'
                ? PERMISSION_MODULES.INTAKE_TRIAGE
                : PERMISSION_MODULES.PRINT_MAIL,
              PERMISSION_ACCESSIBILITY.MANAGE,
              row['programs.id']?.toString()
            )
          const isDisabled =
            isDiscarded(row) ||
            ((authUser?.user?.profile === USER_PROFILES.STANDARD_USER ||
              authUser?.user?.profile === USER_PROFILES.SUPPORT) &&
              (!!row?.disabled ||
                row['users.id'] !== authUser.user?.id ||
                !hasIntakePermission))
          return (
            <ShowEditableIcon
              handleClick={() => {
                if (
                  caseEntityId &&
                  row?.communication_id?.toString().startsWith('L')
                ) {
                  openNewWindow(
                    `/entity/${caseEntityId}/workflow/review/${
                      row?.['cases.id']
                    }?communicationId=${row?.id.toString()}`
                  )
                } else if (
                  isDashboard &&
                  dashboardListName === DASHBOARD.INTAKE
                ) {
                  if (
                    row?.['category_communication_type.label'] !==
                      REPORTS.FAX &&
                    row?.['category_communication_type.label'] !==
                      INTAKE_QUEUE.MAIL
                  ) {
                    navigateWebQueue(
                      `/manage-queue/dynamic-queue/${webQueue[0]?.entity_id}/${webQueue[0]?.layout_id}/${webQueue[0]?.id}/${row?.id}/${caseEntityId}/hcp`,
                      row
                    )
                  } else {
                    if (
                      row?.['category_communication_type.label'] === REPORTS.FAX
                    ) {
                      navigate(
                        `/manage-queue/dynamic-queue/${faxQueue[0]?.entity_id}/${faxQueue[0]?.layout_id}/${faxQueue[0]?.id}/${row?.id}/${caseEntityId}`
                      )
                    } else {
                      navigate(
                        `/manage-queue/dynamic-queue/${mailQueue[0]?.entity_id}/${mailQueue[0]?.layout_id}/${mailQueue[0]?.id}/${row?.id}/${caseEntityId}`
                      )
                    }
                  }
                } else {
                  navigate(
                    `/manage-queue/dynamic-queue/${queueData?.entity_id}/${queueData?.layout_id}/${queueData?.id}/${row?.id}/${caseEntityId}`
                  )
                }
              }}
              isDisabled={isDisabled}
              key={uniqueId()}
            />
          )
        } else return null
      },
    },
    {
      label: DYNAMIC_QUEUE_CONSTANTS.UNASSIGNED,
      key: DYNAMIC_QUEUE_CONSTANTS.UNASSIGNED,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if ((row?.users || row?.['assignee.id']) && !row?.disabled) {
          const hasReassignPermission =
            checkQueType(queueData) !== 'Letter'
              ? permissionObject.Queue_Intake_Reassignment(
                  programPermissions,
                  row['programs.id']?.toString()
                )
              : permissionObject.Queue_Print_Mail_Reassignment(
                  programPermissions,
                  row['programs.id']?.toString()
                )
          return (
            <Unassigned
              handleClick={
                async () =>
                  setModal({
                    type: DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_UNASSIGN_MESSAGE,
                    state: true,
                    index: Number(row?.id),
                    row: row,
                  })
                // Need to check with dev if we need this later
                // await unAssignQueueToReviewer(row?.id, row?.communication_id)
              }
              isDisabled={
                isDiscarded(row) ||
                row['category_status.label'] ===
                  DYNAMIC_QUEUE_CONSTANTS.COMPLETED ||
                ((row['users.id'] !== authUser.user?.id ||
                  !hasReassignPermission) &&
                  !permissionObject.Queue_Bulk_Assignment_Permission(
                    programPermissions,
                    PERMISSION_MODULES.BULK_WORK_ASSIGNMENTS,
                    PERMISSION_ACCESSIBILITY.MANAGE,
                    row['programs.id']?.toString()
                  ))
              }
              key={uniqueId()}
            />
          )
        } else return null
      },
    },
    {
      label: DYNAMIC_QUEUE_CONSTANTS.ASSIGNED,
      key: DYNAMIC_QUEUE_CONSTANTS.ASSIGNED,
      showInPopUp: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (
          row &&
          ((row?.users && !row?.users && !row?.disabled) ??
            !row?.['assignee.id'])
        ) {
          const hasAssigmentPermission =
            checkQueType(queueData) !== 'Letter'
              ? permissionObject.Queue_Intake_Assignment(
                  programPermissions,
                  row['programs.id']?.toString()
                )
              : permissionObject.Queue_Print_Mail_Assignment(
                  programPermissions,
                  row['programs.id']?.toString()
                )
          return (
            <Assigned
              handleClick={async () => {
                await assignQueueToReviewerFunction(
                  row?.id?.toString() ?? '',
                  typeof row?.communication_id === 'string' ||
                    typeof row?.communication_id === 'number'
                    ? row.communication_id
                    : '',
                  row?.['cases.id'],
                  true,
                  row
                )
              }}
              isDisabled={!hasAssigmentPermission || isDiscarded(row)}
              key={uniqueId()}
            />
          )
        } else return null
      },
    },
  ]

  const actions_web: TableActionType<DataTypeStore>[] = [
    {
      label: NAMESPACES.EDIT,
      key: NAMESPACES.EDIT_KEY,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (row?.disabled || (row?.users && !row?.disabled)) {
          return (
            <ShowEditableIcon
              handleClick={() => {
                if (entityid) {
                  queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
                    ? navigate(
                        `/manage-queue/dynamic-queue/${entityid}/${row?.id}`
                      )
                    : navigateWebQueue(`./${row?.id}/${caseEntityId}/hcp`, row)
                }
              }}
              isDisabled={
                isDiscarded(row) ||
                ((authUser?.user?.profile === USER_PROFILES.STANDARD_USER ||
                  authUser?.user?.profile === USER_PROFILES.SUPPORT) &&
                  (row['users.id'] !== authUser.user?.id ||
                    !permissionObject.Queue_Review_Manage_Intake(
                      programPermissions,
                      queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
                        ? PERMISSION_MODULES.MANAGE_ATTACHMENTS
                        : PERMISSION_MODULES.INTAKE_TRIAGE,
                      PERMISSION_ACCESSIBILITY.MANAGE,
                      queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
                        ? row['programs.id']?.toString()
                        : row['hcp_program.id']?.toString()
                    )))
              }
            />
          )
        } else return <></>
      },
    },
    {
      label: DYNAMIC_QUEUE_CONSTANTS.UNASSIGNED,
      key: DYNAMIC_QUEUE_CONSTANTS.UNASSIGNED,
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (row?.users && !row?.disabled) {
          const hasReassignPermission =
            queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
              ? permissionObject.Queue_Document_Reassignment(
                  programPermissions,
                  row['programs.id']?.toString()
                )
              : permissionObject.Queue_Intake_Reassignment(
                  programPermissions,
                  row['hcp_program.id']?.toString()
                )
          return (
            <Unassigned
              handleClick={() =>
                setModal({
                  type: DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_UNASSIGN_MESSAGE,
                  state: true,
                  index: Number(row?.id),
                  row: row,
                })
              }
              isDisabled={
                isDiscarded(row) ||
                ((row['users.id'] !== authUser.user?.id ||
                  !hasReassignPermission) &&
                  !permissionObject.Queue_Bulk_Assignment_Permission(
                    programPermissions,
                    PERMISSION_MODULES.BULK_WORK_ASSIGNMENTS,
                    PERMISSION_ACCESSIBILITY.MANAGE,
                    queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
                      ? row['programs.id']?.toString()
                      : row['hcp_program.id']?.toString()
                  ))
              }
              key={uniqueId()}
            />
          )
        } else return <></>
      },
    },
    {
      label: DYNAMIC_QUEUE_CONSTANTS.ASSIGNED,
      key: DYNAMIC_QUEUE_CONSTANTS.ASSIGNED,
      showInPopUp: false,
      type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
      renderActionComponent: (row: DataType | null) => {
        if (!row?.users && !row?.disabled) {
          const hasAssigmentPermission =
            queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
              ? permissionObject.Queue_Document_Assignment(
                  programPermissions,
                  row?.['programs.id']?.toString() ?? ''
                )
              : permissionObject.Queue_Intake_Assignment(
                  programPermissions,
                  row?.['hcp_program.id']?.toString() ?? ''
                )
          return (
            <Assigned
              handleClick={async () => {
                dispatch(showLoader())
                try {
                  const caseId = row?.['c_case.id']
                  if (caseId) {
                    const dataForEmbedded = {
                      id: caseId,
                      user_id: userId,
                    }
                    await editEntityDataEmbeddedAPI(
                      String(ENTITY_ID.CASE),
                      String(caseId),
                      dataForEmbedded,
                      ['user_id'],
                      true
                    )
                  }
                  await assignCasetoAgentFunctionWeb(
                    row?.id?.toString() ?? '',
                    row?.enrollment_id?.toString(),
                    row
                  )
                } catch (error) {
                  console.error('Failed to assign case:', error)
                } finally {
                  dispatch(hideLoader())
                }
              }}
              isDisabled={!hasAssigmentPermission || isDiscarded(row)}
              key={uniqueId()}
            />
          )
        } else return <></>
      },
    },
  ]

  const navigate = useTenantNavigate()
  const dispatch = useAppDispatch()

  const hasMultiProductSetting = siteSettings?.find(
    (item) => item.key === 'isMultiProductEnabled'
  )?.value
  const hasMultiProduct =
    hasMultiProductSetting === true || hasMultiProductSetting === 'true'

  // Navigate to a web queue / hcp_portal_entity review path, forwarding the
  // multi-product flag via router location state (only when enabled) so it is
  // available before enrollment APIs resolve, without polluting the URL.
  // Also captures enrollment status baseline for status-update popup on Cancel.
  const navigateWebQueue = (
    webReviewPath: string,
    row?: DataType | DataTypeStore | null
  ) => {
    if (hasMultiProduct && row?.id) {
      const enrollmentStatus = getEnrollmentStatusFromQueueRow(row)
      captureInitialIntakeStatus(row.id.toString(), enrollmentStatus, {
        overwrite: true,
      })
    }
    if (hasMultiProduct) {
      navigate(webReviewPath, { state: { hasMultiProduct: true } })
      sessionStorage.setItem('hasMultiProduct', 'true')
    } else {
      navigate(webReviewPath)
      sessionStorage.setItem('hasMultiProduct', 'false')
    }
  }
  const isFirstRender = useRef<boolean>(true)
  const lastFetchSignatureRef = useRef<string | null>(null)
  const isPageResetInProgressRef = useRef<boolean>(false)

  const [currentPage, setCurrentPage] = useState<number>(
    FIELD_VALUE_CONSTANTS.ONE
  )
  const [rowPerPage, setRowPerPage] = useState<number>(
    FIELD_VALUE_CONSTANTS.TEN
  )
  const [faxDocumentDetails, setFaxDocumentDetails] = useState<{
    users_id: string
    programs_id: string
    isOpen: boolean
    faxId: number
    faxName: string
    communicationId: number | string
    case_id?: string
    selectedRow?: DataType | null | undefined
    document_id?: number
    element?: ElementType
    multipleDocument?: boolean
  }>({
    users_id: '-1',
    programs_id: '-1',
    isOpen: false,
    faxId: 0,
    faxName: '',
    communicationId: 0,
    case_id: '',
  })
  const [caseEntityId, setCaseEntityId] = useState<number | undefined>(
    caseEntityIdProp
  )
  const [queueRowsData, setQueueRowsData] = useState<DataTypeStore[]>([])

  const onSortClick = (key: string, isAsc: SORT_KEYS) => {
    if (key) {
      setSortDirection(() => {
        const newKeyName = key
        const direction = isAsc
        return {
          keyName: isAsc === SORT_KEYS.Disabled ? '' : newKeyName,
          direction: direction,
          key: isAsc === SORT_KEYS.Disabled ? '' : key,
          isAsc: isAsc,
        }
      })
    }
  }

  const openNewWindow = (path: string) => {
    // Hand openWithTenant a ROOTED PATH, not an absolute URL.
    //
    // This used to prepend window.location.origin itself. That made the string
    // absolute, so openWithTenant's `url.startsWith('/')` internal-path check
    // failed and appendTenantIdToPath was skipped entirely — the tenant segment
    // was never added. Opening /entity/32/workflow/review/<id> from /1003 gave
    // https://<host>/entity/32/... with no tenant, which React Router binds to
    // :tenantId="entity", matches no child route, and renders a blank tab.
    //
    // Passing the path through lets openWithTenant resolve the tenant from the
    // current URL, matching the openNewWindow in helperFunctions.ts and
    // ListingTableFromLayout.tsx.
    openWithTenant(path.startsWith('/') ? path : `/${path}`, '_blank')
  }

  const handleHeaderFromSelected = () => {
    const checkPrintQueue = checkQueType(queueData) === 'Letter'
    const selected = !headerValues?.selected
    const newData = entityData.map((dataItem) => {
      const hasBulkPermission = permissionObject.Queue_Bulk_Assignment(
        programPermissions,
        dataItem,
        queueData?.entity_name?.toLowerCase(),
        checkPrintQueue
      )
      const assignedUserId = dataItem['users.id']
      const isUnassigned = !assignedUserId
      const shouldBeSelectable = hasBulkPermission || isUnassigned
      return {
        ...dataItem,
        selected: shouldBeSelectable ? selected : dataItem.selected,
      }
    })
    setEntityData(newData)
    const newSelectedRows = selected
      ? entityData
          .filter((row) => {
            const hasBulkPermission = permissionObject.Queue_Bulk_Assignment(
              programPermissions,
              row,
              queueData?.entity_name?.toLowerCase(),
              checkPrintQueue
            )
            const assignedUserId = row['users.id'] || row['user_id']
            const isUnassigned = !assignedUserId
            const shouldBeSelectable = hasBulkPermission || isUnassigned
            return (
              String(row.id) !== 'undefined' &&
              shouldBeSelectable &&
              !isDiscarded(row)
            )
          })
          .map((row) => String(row.id))
      : []
    setSelectedRows(newSelectedRows)
    setHeaderValues((prev) => {
      return { ...prev, selected: !prev?.selected }
    })
    setCompleteSelectedRows(newData)
  }

  const handleSelected = (rowIndex: number | null) => {
    if (!isNull(rowIndex) && rowIndex >= 0 && rowIndex < entityData.length) {
      const newState = [...entityData]
      const element = { ...newState[rowIndex] }
      element.selected = !element.selected
      newState[rowIndex] = element
      const updatedSelectedRows = element.selected
        ? [...selectedRows, String(element.id)]
        : selectedRows.filter((id) => id !== String(element.id))

      setSelectedRows(updatedSelectedRows)
      setCompleteSelectedRows((prev: DataType[]) =>
        element.selected
          ? [...prev, element]
          : prev.filter((row) => String(row.id) !== String(element.id))
      )
      const allSelected = updatedSelectedRows.length === newState.length
      setHeaderValues((prev) => ({
        ...prev,
        selected: allSelected,
      }))
      setEntityData([...newState])
    }
  }

  const fetchDocuments = async (id: string) => {
    const communicationId = parseNumericId(id)
    if (communicationId === null) {
      return
    }

    try {
      dispatch(showLoader())
      const payload = {
        entity_name: QUEUE_STRINGS?.COMMUNICATION_LOWERCASE,
        select: ['document'],
        related_entities: {
          document: {
            select: ['attachment'],
          },
        },
      }
      const response = await fetchCommunicationIdCorrespondingData(
        communicationId,
        payload
      )
      return response?.data
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleFaxDocumentDetails = async (
    row: DataType | null | undefined,
    communicationIdKey: string,
    nameKey: string
  ) => {
    if (isDiscarded(row)) return
    let programsId = '-1'
    if (row) {
      programsId =
        communicationIdKey === QUEUE_STRINGS.COMMUNICATION_ID
          ? row['programs.id']?.toString()
          : row['hcp_program.id']?.toString()
    }
    let el
    let isMultiDocument = false
    if (communicationIdKey === QUEUE_STRINGS.COMMUNICATION_ID) {
      const res = await fetchDocuments(row?.id?.toString() ?? '')
      isMultiDocument = res?.document?.attachment?.length > 1 ? true : false
      const layout =
        listingLayout?.layout_data?.pages?.[0]?.rows?.[0]?.columns?.[0].elements?.filter(
          (val) => val.keyName === 'document'
        )
      el = getElementFromAddedFields(
        layout?.[0] as unknown as LayoutElementType,
        listingLayout?.entity_id?.toString() ?? '',
        listingLayout?.layout_data?.added_fields
      )
    }

    setFaxDocumentDetails({
      users_id: row ? row['users.id']?.toString() : '-1',
      programs_id: programsId,
      isOpen: true,
      faxId: parseInt(row?.id?.toString() ?? ''),
      faxName: row?.[nameKey]?.toString() ?? '',
      communicationId: parseInt(row?.[nameKey]?.toString() ?? '-1'),
      ...(communicationIdKey === QUEUE_STRINGS.COMMUNICATION_ID
        ? {
            case_id: row ? row['cases.id']?.toString() : '',
          }
        : {}),
      selectedRow: row,
      document_id: parseInt(row?.['document.id']?.toString() ?? ''),
      element: el,
      multipleDocument: isMultiDocument,
    })
  }

  const handleNavigation = (path: string) => {
    openNewWindow(path)
  }

  const onColumnClick = async (
    isHeader: boolean,
    KeyName: keyof DataType,
    row?: DataType | null,
    rowIndex: number | null = null
  ) => {
    if (KeyName === DYNAMIC_QUEUE_CONSTANTS.SELECTED) {
      isHeader ? handleHeaderFromSelected() : handleSelected(rowIndex)
      return
    }

    if (!row) return

    switch (KeyName) {
      case QUEUE_STRINGS.COMMUNICATION_ID:
      case QUEUE_STRINGS.FAX_NAME:
        handleFaxDocumentDetails(
          row,
          QUEUE_STRINGS.COMMUNICATION_ID,
          'communication_id'
        )
        break

      case QUEUE_STRINGS.ENROLLMENT_ID:
        handleFaxDocumentDetails(
          row,
          QUEUE_STRINGS.ENROLLMENT_ID,
          'enrollment_id'
        )
        break
      case QUEUE_STRINGS.INTAKE_ID_KEY:
        handleFaxDocumentDetails(
          row,
          QUEUE_STRINGS.INTAKE_ID_KEY,
          QUEUE_STRINGS.INTAKE_ID_KEY
        )
        break

      case QUEUE_STRINGS.CASE_ID_KEY:
        try {
          dispatch(showLoader())
          if (isCaseWorkBasket || isDashboard) {
            openNewWindow(`/entity/${caseEntityId}/workflow/review/${row?.id}`)
            return
          }
          const migrated = await getMigrationStatus(Number(row?.id))
          if (migrated) {
            const layoutId = await getMigratedLayoutId()
            openNewWindow(`/entities/32/tab/${row?.id}?layoutId=${layoutId}`)
          } else {
            await handleOpenLink(
              row?.id as number,
              caseEntityId,
              row?.service_id as number
            )
          }
        } catch (err) {
          console.error(err)
        } finally {
          dispatch(hideLoader())
        }
        break

      case QUEUE_STRINGS.CASES_KEY:
        openNewWindow(
          `/entity/${entityid}/workflow/review/${row['cases.id']}?communicationId=${row.id}`
        )
        break

      case QUEUE_STRINGS.TASK_CASE_ID:
        openNewWindow(
          `/entity/${caseEntityId}/workflow/review/${row?.case_primary_id}`
        )
        break

      case QUEUE_STRINGS.TASK_CODE:
        handleNavigation(
          `/entity/${caseEntityId}/workflow/review/${row.case_primary_id}?TASK_ID=${row?.record_id}`
        )
        break

      case QUEUE_STRINGS.TASK_ID:
        handleNavigation(
          `/entity/${caseEntityId}/workflow/review/${row.case_primary_id}?TASK_ID=${row?.record_id}`
        )
        break

      case NAMESPACES.NAME_KEY:
        navigate(`entity/${row.id}/overview`)
        break
    }
  }

  const onActionClick = (
    actionKeyName: string,
    row: DataType,
    _rowIndex: number
  ) => {
    if (actionKeyName === NAMESPACES.EDIT) {
      navigate(`/entity-manager/entity/${row?.id}`)
    }
  }

  const onFilterChange = (value: TableFilterObjectBody) => {
    setApiFilter(value)
    sendFilterDataFromChild(value)
    setCurrentPage(FIELD_VALUE_CONSTANTS.ONE)
    isMounted.current = true
  }

  const handlePageChange = async (page: number, rows: number) => {
    if (isFirstRender?.current) return
    if (isPageResetInProgressRef.current) {
      isPageResetInProgressRef.current = false
      return
    }
    try {
      dispatch(showLoader())
      setRowPerPage(rows)
      const currentPage = rows !== rowPerPage ? 1 : page
      setCurrentPage(currentPage)
      sendPageDataToDynamicQueue(currentPage)
      await fetchEntityData(apiFilter, rows, currentPage - 1)
      setSelectedRows([])
      setCompleteSelectedRows([])
      setHeaderValues({ selected: false })
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getValuesForKey = (
    relatedEntities: RelatedEntitiesForQueue | undefined,
    key: string,
    searchTerm = ''
  ): string[] | false => {
    const entity = relatedEntities?.[key]
    if (!entity) return false

    const values =
      entity.filters?.flatMap(
        (filter) => filter.criteria?.flatMap((c) => c.values ?? []) ?? []
      ) ?? []

    if (!searchTerm.trim()) return values

    return values.filter((v) =>
      v.toLowerCase().includes(searchTerm.toLowerCase())
    )
  }
  const getStringOptions = async (
    searchCriteria: SearchCriteria,
    page: number,
    size: number,
    targetEntityId?: number,
    fieldName?: string,
    isSingleLookup?: boolean
  ) => {
    try {
      let response
      const entity_name = listingLayout?.entity_name
      if (
        !checkFilterColumn(
          entity_name ?? '',
          searchCriteria.search_key ?? ''
        ) ||
        isDashboard
      )
        return { data: [], size: 0 }

      if (searchCriteria.search_key === NAMESPACES.ENROLLMENT_STATUS) {
        return getWebEnrollmentStatusFilterOptions({
          searchTerm: searchCriteria.search_value?.[0] ?? '',
          page,
          size,
          cacheRef: enrollmentStatusCacheRef,
          categoryType: NAMESPACES.WEB_ENROLLMENT_STATUS,
        })
      }
      const select = [
        ...new Set([
          fieldName ?? '',
          ...queueFilterCriteria.map((q) => q.field_name),
        ]),
      ]
      if (isSingleLookup) {
        const result = getValuesForKey(
          queueFilterRealtedEntities,
          searchCriteria.search_key,
          searchCriteria.search_value[0]
        )
        if (Array.isArray(result)) {
          return { data: result, size: 0 }
        }
        const payload = {
          entity_id: targetEntityId,
          select: select,
          distinct: true,
          filters: [
            {
              criteria: [
                {
                  field_name: fieldName,
                  operation: searchCriteria.operator,
                  values: searchCriteria.search_value,
                },
              ],
            },
          ],
          page: page - 1,
          size: size,
        }
        response = await getOptionsOnFocus(payload)
      } else {
        const filterCriteriaForQueue: FilterCriteriaForQueue[] = [
          {
            field_name: fieldName ?? '',
            values: searchCriteria?.search_value,
            operation: 'LIKE',
          },
          {
            field_name: fieldName ?? '',
            direction: 'ASC',
          },
        ]
        const cleanedQueue: FilterCriteriaForQueue[] = queueFilterCriteria.map(
          (item) => ({
            id: item.id,
            field_name: item.field_name,
            operation: item.operation,
            sort_direction: item.sort_direction ?? undefined,
            values: item.values,
          })
        )
        filterCriteriaForQueue.push(...cleanedQueue)
        const select = [
          ...new Set([
            fieldName ?? '',
            ...filterCriteriaForQueue.map((q) => q.field_name),
          ]),
        ]
        const payload = {
          entity_id: targetEntityId,
          select: select,
          distinct: true,
          filters: [
            {
              criteria: filterCriteriaForQueue,
            },
          ],
          page: page - 1,
          size: size,
        }
        response = await getOptionsOnFocus(payload)
      }
      return {
        data: response?.data?.content
          ?.filter((item: { [key: string]: string }) => {
            const value = item[fieldName ?? '']
            return value !== null && value.trim() !== ''
          })
          .map((item: { [key: string]: string }) => item[fieldName ?? '']),
        size: response?.data?.content?.length,
      }
    } catch (err) {
      console.error(err)
      return { data: [], size: 0 }
    }
  }

  const wrappedGetStringOptions = async (
    searchCriteria: SearchCriteria,
    targetEntityId?: number,
    fieldName?: string,
    isSingleLookup?: boolean
  ) => {
    const response = await getStringOptions(
      searchCriteria,
      1,
      10,
      targetEntityId,
      fieldName,
      isSingleLookup
    )
    return response?.data ?? []
  }
  const getTableHeadersFromLayout = (
    isCaseWorkbasket = false
  ): TableColumnType<DataTypeStore>[] => {
    const entityName = queueData?.entity_name?.toLowerCase() ?? ''

    const getType = (keyName: string): string => {
      const isHyperlink = (keys: string[]) => keys.includes(keyName)
      if (isDashboard) {
        return keyName === QUEUE_STRINGS.CASE_ID_KEY ||
          keyName === QUEUE_STRINGS.COMMUNICATION_ID ||
          keyName === QUEUE_STRINGS.ENROLLMENT_ID ||
          keyName === QUEUE_STRINGS.TASK_ID ||
          keyName === QUEUE_STRINGS.TASK_CASE_ID
          ? QUEUE_STRINGS.HYPERLINK
          : ''
      }

      switch (entityName) {
        case ENTITY_NAME.CASE_LOWER:
          return keyName === QUEUE_STRINGS.CASE_ID_KEY
            ? QUEUE_STRINGS.HYPERLINK
            : ''

        case ENTITY_NAME.TASK:
          return isHyperlink([
            QUEUE_STRINGS.TASK_CASE_ID,
            QUEUE_STRINGS.TASK_CODE,
            QUEUE_STRINGS.TASK_ID,
          ])
            ? QUEUE_STRINGS.HYPERLINK
            : ''

        case ENTITY_NAME.HCP_PORTAL_ENTITY:
          return keyName === QUEUE_STRINGS.ENROLLMENT_ID
            ? QUEUE_STRINGS.HYPERLINK
            : ''

        case ENTITY_NAME.COMMUNICATION:
          return isHyperlink([
            QUEUE_STRINGS.COMMUNICATION_ID,
            QUEUE_STRINGS.CASES_KEY,
          ])
            ? QUEUE_STRINGS.HYPERLINK
            : ''

        default:
          return ''
      }
    }

    const checkPrintQueue = checkQueType(queueData) === 'Letter'
    let tableHeader: TableColumnType<DataTypeStore>[] =
      listingLayout?.layout_data?.pages?.[0].rows?.[0].columns?.[0].elements
        ?.filter((element) => !element?.is_hidden)
        .map((element) => {
          const isCreatedAt = element.keyName === NAMESPACES.CREATED_AT
          const isReceivedOn = element.keyName === 'received_on'
          const keyAccessor = element.parent?.lookupKeyName
            ? `${element.parent.lookupKeyName}.${element.keyName}`
            : element.keyName ?? ''
          const addedField =
            listingLayout?.layout_data?.added_fields?.[element?.keyName ?? '']

          const layoutFix = Object.keys(addedField?.added_fields ?? {})
          const baseColumn = {
            header:
              listingLayout?.layout_data?.added_fields?.[element?.keyName ?? '']
                ?.label ??
              element.meta?.label ??
              '',
            accessor: keyAccessor,
            minWidth: '3',
            filterData: buildFilterData(
              listingLayout?.entity?.entity_name ?? '',
              element,
              keyAccessor === 'sender_name',
              getStringOptions,
              wrappedGetStringOptions,
              false,
              listingLayout?.layout_data?.added_fields?.[
                element?.keyName ?? ''
              ],
              listingLayout.name ?? '',
              undefined,
              isDashboard
            ),
            isSortable:
              element.keyName === 'overdue_time' ? true : !element?.parent,
            isLookup:
              element?.elementName === componentNames.SINGLE_LOOKUP ||
              element?.elementName === componentNames.CATEGORY,
            LookupConfig:
              listingLayout?.layout_data?.added_fields?.[
                element?.keyName ?? ''
              ]?.selected_fields?.map((field) => field?.field_name ?? '') ?? [],
            lookupAddedFields: layoutFix ?? [],
          }

          if (element.elementName === componentNames.MULTI_LOOKUP) {
            return {
              ...baseColumn,
              type: columnTypesConst.COMPONENT,
              isSortable: false,
              renderComponent: getMultiLookUpForListingTable(
                listingLayout?.layout_data?.added_fields?.[keyAccessor]
                  ?.relationship as EntityFieldRelationshipType,
                listingLayout?.entity?.entity_name ?? entityName,
                keyAccessor,
                listingLayout as unknown as LayoutResponseType,
                false,
                NAMESPACES.VIEW_DETAILS,
                element?.keyName ===
                  ENTITY_NAME.HCP_ENROLLMENT_ASSOCIATED_DETAILS_VIEW
                  ? getWebQueueDetailsModalTitle
                  : undefined
              ),
              filterData: undefined,
            }
          }

          if (isCreatedAt || (isReceivedOn && isDashboard)) {
            return {
              ...baseColumn,
              type: 'component',
              renderComponent: (item, _rowIndex) => {
                const status = item.sla_status ?? item.status
                if (status) {
                  let statusClass: string
                  if (
                    status === NAMESPACES.OVERDUE ||
                    status === REPORTS.OVERDUE
                  ) {
                    statusClass = 'bg-red-100 border-red-600'
                  } else if (
                    status === NAMESPACES.AT_RISK ||
                    status === REPORTS.AT_RISK
                  ) {
                    statusClass = 'bg-yellow-100 border-yellow-700'
                  } else {
                    statusClass = 'bg-green-100 border-green-700'
                  }
                  return (
                    <div
                      className={`text-xs font-light border-l-2 rounded-tr-sm rounded-br-sm p-2 flex items-center ${statusClass}`}
                    >
                      {item.created_at ?? item.received_on ?? '--'}
                    </div>
                  )
                } else {
                  return (
                    <div className={`text-xs font-light flex items-center`}>
                      {item.created_at ?? item.received_on ?? '--'}
                    </div>
                  )
                }
              },
            }
          }
          if (element.keyName === 'urgency_index_status') {
            return {
              ...baseColumn,
              accessor: 'urgency_index_status',
              type: 'component',
              renderComponent: (row) => {
                const value = row?.urgency_index_status
                if (!value) {
                  return <div className="text-xs p-2 font-light">--</div>
                }

                let statusClass = ''
                if (value === REPORTS.OVERDUE)
                  statusClass = 'bg-red-100 border-red-600'
                else if (value === REPORTS.AT_RISK)
                  statusClass = 'bg-yellow-100 border-yellow-700'
                else if (value === REPORTS.ON_TRACK)
                  statusClass = 'bg-green-100 border-green-700'
                else if (value === REPORTS.PAUSED)
                  statusClass = 'bg-blue-100 border-blue-500'

                return (
                  <div
                    className={`rounded-r-sm px-2 text-xs align-middle font-light border-l-2 ${statusClass}`}
                  >
                    {value}
                  </div>
                )
              },
            }
          } else {
            return {
              ...baseColumn,
              type: getType(element.keyName ?? ''),
            }
          }
        }) || []
    if (isCaseWorkbasket) {
      tableHeader = removeColumns(tableHeader, TABLE_HEADER_KEYS_ARRAY)
    } else if (dashboardListName !== DASHBOARD.MY_TASK) {
      tableHeader.unshift({
        header: DYNAMIC_QUEUE_CONSTANTS.CHECKBOX,
        accessor: DYNAMIC_QUEUE_CONSTANTS.SELECTED,
        type: DYNAMIC_QUEUE_CONSTANTS.COMPONENT,
        showInColumnChooser: false,
        renderHeader: (onColumnClick, headerValues) => {
          const isEnabled = entityData?.find((entity) =>
            permissionObject.Queue_Bulk_Assignment(
              programPermissions,
              entity,
              entityName,
              checkPrintQueue
            )
          )
          const isDiscard = !!queueRowsData?.find((row) => isDiscarded(row))
          return (
            <div className="flex justify-center items-center">
              <input
                type="checkbox"
                className="h-[1.125rem] w-[1.125rem] accent-secondary-500"
                checked={!!headerValues?.[DYNAMIC_QUEUE_CONSTANTS.SELECTED]}
                onChange={(e) => {
                  isEnabled
                    ? onColumnClick(true, DYNAMIC_QUEUE_CONSTANTS.SELECTED)
                    : noop()
                  e?.stopPropagation()
                }}
                data-qa-id={`checkbox_bulk`}
                disabled={!isEnabled || isDiscard || isReadOnlyUser()}
              />
            </div>
          )
        },
        isEnabledOnDisabledRow: true,
        renderComponent: (row, rowIndex, onColumnClick) => {
          const isEnabled = permissionObject.Queue_Bulk_Assignment(
            programPermissions,
            row,
            entityName,
            checkPrintQueue
          )
          return (
            <div className="flex justify-center items-center">
              <input
                type="checkbox"
                className="h-[1.125rem] w-[1.125rem] accent-secondary-500"
                disabled={!isEnabled || isDiscarded(row) || isReadOnlyUser()}
                checked={!!row?.[DYNAMIC_QUEUE_CONSTANTS.SELECTED]}
                onClick={(e) => e.stopPropagation()}
                onChange={() =>
                  isEnabled
                    ? onColumnClick(
                        false,
                        DYNAMIC_QUEUE_CONSTANTS.SELECTED,
                        row,
                        rowIndex
                      )
                    : noop()
                }
                data-qa-id={`checkbox_${rowIndex}`}
              />
            </div>
          )
        },
      })
    }
    return tableHeader ?? []
  }

  const assignCasetoAgentFunction = async (
    caseId: string,
    row: DataType,
    case_key?: string
  ) => {
    try {
      const agentId = authUser?.user
      const agent = {
        label: `${agentId?.first_name} ${agentId?.last_name} | ${agentId?.user_id}`,
        value: agentId?.user_id ?? '',
        id: agentId?.id ?? 0,
        status: DYNAMIC_QUEUE_CONSTANTS.UNAVAILABLE,
      }

      let canProceed = true
      if (
        authUser?.user?.profile === USER_PROFILES.STANDARD_USER ||
        authUser?.user?.profile === USER_PROFILES.SUPPORT
      ) {
        const response = await postValidateCasesWithAgent(
          (agent?.id ?? '')?.toString(),
          [caseId]
        )
        canProceed = !!response
      }

      const successMessage = `${NAMESPACES.CASES_ASSIGNED_MESSAGE} ${case_key}.`
      if (canProceed) {
        let success
        if (isDashboard && handleAssignUnassignForDashboard) {
          success = await handleAssignUnassignForDashboard(agent, [row])
        } else {
          success = await assignCasesWithAgent(
            [caseId],
            agent,
            layoutid?.toString(),
            entityid?.toString(),
            entityName ?? 'case'
          )
        }
        if (success) {
          setSelectedRows([])
          setCompleteSelectedRows([])
          setHeaderValues({ selected: false })
          dispatch(
            addToaster({
              id: uuid(),
              message: successMessage,
              type: 'success',
            })
          )
        }
      }
      fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
      if (caseId) {
        if (isDashboard) {
          openNewWindow(
            `/entity/${
              ENTITY_NAME.CASE_ENTITY_ID
            }/workflow/review/${caseId}?message=${encodeURIComponent(
              successMessage
            )}`
          )
        } else {
          openNewWindow(
            `/entity/${entityid}/workflow/review/${caseId}?message=${encodeURIComponent(
              successMessage
            )}`
          )
        }
      }
    } catch (error) {
      console.error(error)
      const errorMessage =
        (error as AxiosError<ErrorResponseData>).response?.data?.message ?? ''
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleAssignDocumentToAgent = async (caseId: string) => {
    try {
      dispatch(showLoader())
      const data = {
        users: {
          id: authUser?.user?.id ?? 0,
          _state: RECORD_STATE.ADDED,
        },
      }
      return await editEntityDataEmbeddedAPI(
        entityName ?? ENTITY_NAME?.AE_PC_DOCUMENT,
        caseId,
        data,
        ['users']
      )
    } catch (err) {
      console.error(err)
      const errorMessage =
        (err as AxiosError<ErrorResponseData>).response?.data?.message ??
        DYNAMIC_QUEUE_MESSAGES.CASE_ALREADY_ASSIGNED
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  const assignCasetoAgentFunctionWeb = async (
    caseId: string,
    enrollmentId?: string,
    selectedRow?: DataType | DataTypeStore | null
  ) => {
    try {
      const agentId = authUser?.user
      const agent = {
        label: `${agentId?.first_name} ${agentId?.last_name} | ${agentId?.user_id}`,
        value: agentId?.user_id ?? '',
        id: agentId?.id ?? 0,
        status: DYNAMIC_QUEUE_CONSTANTS.UNAVAILABLE,
      }

      const idToAssign =
        hasMultiProduct &&
        (entityName ?? QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE) ===
          QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE
          ? enrollmentId ?? caseId
          : caseId

      const success =
        entityName === ENTITY_NAME?.AE_PC_DOCUMENT && !hasMultiProduct
          ? await handleAssignDocumentToAgent(caseId)
          : await assignCasesWithAgent(
              [idToAssign],
              agent,
              layoutid?.toString(),
              entityid?.toString(),
              entityName ?? QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE,
              hasMultiProduct
            )
      if (!success) return
      if (success) {
        setSelectedRows([])
        setCompleteSelectedRows([])
        setHeaderValues({ selected: false })
        dispatch(
          addToaster({
            id: uuid(),
            message: `${DYNAMIC_QUEUE_MESSAGES.ASSIGN_INTAKE_TO_AGENT} ${agentId?.first_name} ${agentId?.last_name}.`,
            type: 'success',
          })
        )
      }
      if (entityid) {
        if (entityName === ENTITY_NAME?.AE_PC_DOCUMENT) {
          navigate(`/manage-queue/dynamic-queue/${entityid}/${caseId}`)
        } else {
          navigateWebQueue(
            `/manage-queue/dynamic-queue/${entityid}/${layoutid}/${id}/${caseId}/${caseEntityId}/hcp`,
            selectedRow ?? { id: caseId }
          )
        }
      }
      if (
        isDashboard &&
        dashboardListName === DASHBOARD.DOCUMENT &&
        handleAssignUnassignForDashboard
      ) {
        await handleAssignUnassignForDashboard(null, [])
      }
    } catch (error) {
      console.error(error)
      const errorMessage =
        (error as AxiosError<ErrorResponseData>).response?.data?.message ??
        DYNAMIC_QUEUE_MESSAGES.ERROR_VALIDATE_CASE_WITH_AGENT
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const getActionsProp = (
    queueData: DynamicQueuesType | undefined
  ): TableActionType<DataTypeStore>[] => {
    if (
      queueData?.entity_name?.toLowerCase() === ENTITY_NAME.CASE_LOWER ||
      queueData?.entity_name?.toLowerCase() === ENTITY_NAME.TASK ||
      (isDashboard &&
        (dashboardListName === ENTITY_NAME.CASE ||
          dashboardListName === DASHBOARD.MY_TASK))
    ) {
      // if (queueData?.name === 'Migrated Case Queue') {
      //   return migrationQueueActionsForCase
      // } else {
      return genericQueueActionsForCase
      // }
    } else if (queueData?.entity_name === ENTITY_NAME.COMMUNICATION) {
      return actions
    } else if (
      queueData?.entity_name === QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE ||
      queueData?.entity_name === ENTITY_NAME?.AE_PC_DOCUMENT
    ) {
      return actions_web
    } else {
      return genericQueueActions
    }
  }

  const getHeaderForModal = () => {
    if (entityName === ENTITY_NAME.HCP_PORTAL_ENTITY) {
      return WEB_PREVIEW.ENROLLMENT_ID
    }
    if (faxDocumentDetails.faxName.startsWith('M')) {
      return DYNAMIC_QUEUE_MESSAGES.MAIL_ID
    }
    if (!faxDocumentDetails.faxName.startsWith('L')) {
      return DYNAMIC_QUEUE_MESSAGES.FAX_ID
    }
    return DYNAMIC_QUEUE_MESSAGES.LETTER_ID
  }

  const determineEmptyDataMessage = (
    queueData: DynamicQueuesType | undefined,
    isCaseWorkBasket: boolean | undefined,
    isTaskWorkBasket: boolean | undefined
  ): string => {
    if (isCaseWorkBasket) {
      return EMPTY_TABLE_DATA_MESSAGE.NO_CASE_ASSIGNED
    }

    if (isTaskWorkBasket) {
      return EMPTY_TABLE_DATA_MESSAGE.NO_TASK_ASSIGNED
    }

    const entityName = queueData?.entity_name

    if (entityName === ENTITY_NAME.HCP_PORTAL_ENTITY) {
      return EMPTY_TABLE_DATA_MESSAGE.NO_WEB_AVAILABLE
    }

    const filters =
      queueData?.related_entities?.category_communication_type?.filters

    if (filters) {
      const criteriaList = filters.flatMap(
        (filter) =>
          (filter as { logical_operator?: string; criteria: QueueCriterum[] })
            .criteria
      )

      const firstValidValue = criteriaList.find(
        (criterion: QueueCriterum) =>
          Array.isArray(criterion.values) && criterion.values[0]
      )?.values[0]

      if (
        firstValidValue?.toLowerCase() ===
        ENTITY_NAME.COMM_TYPE_LETTER.toLowerCase()
      ) {
        return EMPTY_TABLE_DATA_MESSAGE.NO_LETTERS_AVAILABLE
      }
    }

    if (entityName === ENTITY_NAME.COMMUNICATION) {
      if (queueData?.name === QUEUE_STRINGS.MAIL) {
        return EMPTY_TABLE_DATA_MESSAGE.NO_MAILS_AVAILABLE
      }
      return EMPTY_TABLE_DATA_MESSAGE.NO_FAXES_AVAILABLE
    }

    return EMPTY_TABLE_DATA_MESSAGE.NO_RECORDS_FOUND
  }

  const isEditButtonVisible = () => {
    return (
      isSuperAdmin() ||
      !(
        faxDocumentDetails.users_id !== authUser.user?.id?.toString() ||
        !permissionObject.Queue_Review_Manage_Intake(
          programPermissions,
          PERMISSION_MODULES.INTAKE_TRIAGE,
          'Manage',
          faxDocumentDetails.programs_id
        )
      ) ||
      (faxDocumentDetails.users_id === authUser.user?.id?.toString() &&
        queueType === COMM_TEMPLATE.LETTER_LOWECASE)
    )
  }

  useEffect(() => {
    setRowPerPage(rowsPerPage)
  }, [rowsPerPage])

  useEffect(() => {
    setCaseEntityId(caseEntityIdProp)
  }, [caseEntityIdProp])

  useEffect(() => {
    if (entityData) {
      setQueueRowsData(entityData)
    }
  }, [entityData])

  // Need to check with developer
  // useEffect(() => {
  //   setApiFilter({})
  // }, [entityid, layoutid, id])

  // Need to check with developer
  // useEffect(() => {
  //   if (
  //     apiFilter ||
  //     (sortDirection &&
  //       (isSuperAdmin() || Object.keys(programPermissions).length))
  //   ) {
  //   alert(234)
  //     fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
  //   }
  // }, [sortDirection, programPermissions])

  // useEffect(() => {
  //   if (
  //     apiFilter ||
  //     (sortDirection &&
  //       (isSuperAdmin() || Object.keys(programPermissions).length))
  //   ) {
  //     alert(5456)
  //     setCurrentPage(FIELD_VALUE_CONSTANTS.ONE)
  //     fetchEntityData(apiFilter, rowPerPage, currentPage - 1, true)
  //   }
  // }, [apiFilter])

  useEffect(() => {
    if (
      !isCaseWorkBasket &&
      !isTaskWorkBasket &&
      !isMounted.current &&
      !isDashboard
    )
      return
    if (!listingLayout) return
    if (
      isDemoDashboardChanges &&
      !sortDirection.key &&
      lastFetchSignatureRef.current === null
    ) {
      const createdAtElement =
        listingLayout?.layout_data?.pages?.[0]?.rows?.[0]?.columns?.[0]?.elements?.find(
          (element) =>
            element.keyName === NAMESPACES.CREATED_AT && !element?.is_hidden
        )

      if (createdAtElement?.keyName) {
        const createdAtKey = createdAtElement.parent?.lookupKeyName
          ? `${createdAtElement.parent.lookupKeyName}.${createdAtElement.keyName}`
          : createdAtElement.keyName

        setSortDirection({
          keyName: createdAtKey,
          direction: SORT_KEYS.Desc,
          isAsc: SORT_KEYS.Desc,
          key: createdAtKey,
        })
        return
      }
    }
    const shouldFetch =
      apiFilter ||
      (sortDirection &&
        (isSuperAdmin() || Object.keys(programPermissions).length))

    if (!shouldFetch) return

    const fetchSignature = [
      listingLayout?.id,
      sortDirection?.key,
      sortDirection?.direction,
      refetchKeyFromDashboard,
      apiFilter ? JSON.stringify(apiFilter) : '',
      Object.keys(programPermissions).sort().join(','),
    ].join('|')

    if (lastFetchSignatureRef.current === fetchSignature) return
    lastFetchSignatureRef.current = fetchSignature

    // Reset page if apiFilter changes
    if (apiFilter || refetchKeyFromDashboard) {
      isPageResetInProgressRef.current = true
      setCurrentPage(FIELD_VALUE_CONSTANTS.ONE)
      fetchEntityData(apiFilter, rowPerPage, 0, true)
    } else {
      fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
    }
  }, [
    apiFilter,
    sortDirection,
    programPermissions,
    listingLayout,
    isMounted?.current,
    refetchKeyFromDashboard,
    isDemoDashboardChanges,
    isDashboard,
  ])

  // useEffect(() => {

  //   if (isCaseWorkBasket) {
  //     setEmptyDataMessage(EMPTY_TABLE_DATA_MESSAGE.NO_CASE_ASSIGNED)
  //   } else if (isTaskWorkBasket) {
  //     setEmptyDataMessage(EMPTY_TABLE_DATA_MESSAGE.NO_TASK_ASSIGNED)
  //   } else if (queueData?.entity_name === ENTITY_NAME.COMMUNICATION) {
  //     setEmptyDataMessage(EMPTY_TABLE_DATA_MESSAGE.NO_FAXES_AVAILABLE)
  //   } else if (queueData?.entity_name === ENTITY_NAME.HCP_PORTAL_ENTITY) {
  //     setEmptyDataMessage(EMPTY_TABLE_DATA_MESSAGE.NO_WEB_AVAILABLE)
  //   } else setEmptyDataMessage(EMPTY_TABLE_DATA_MESSAGE.NO_RECORDS_FOUND)

  //   const filters = queueData?.related_entities?.category_communication_type?.filters;

  // if (filters) {
  //   const criteriaList = filters.flatMap(
  //     (filter) => (filter as { logical_operator?: string; criteria: QueueCriterum[] }).criteria
  //   );

  //   const firstValidValue = criteriaList.find(
  //     (criterion: QueueCriterum) =>
  //       Array.isArray(criterion.values) && criterion.values[0]
  //   )?.values[0];

  //   if (firstValidValue?.toLowerCase() === ENTITY_NAME.COMM_TYPE_LETTER) {
  //     setEmptyDataMessage(EMPTY_TABLE_DATA_MESSAGE.NO_LETTERS_AVAILABLE);
  //   }
  // }

  // }, [isCaseWorkBasket, isTaskWorkBasket, queueData])

  useEffect(() => {
    const message = determineEmptyDataMessage(
      queueData,
      isCaseWorkBasket,
      isTaskWorkBasket
    )
    setEmptyDataMessage(message)
  }, [queueData, isCaseWorkBasket, isTaskWorkBasket])

  useEffect(() => {
    if (isFirstRender?.current) {
      isFirstRender.current = false
      return
    }
  }, [])

  useEffect(() => {
    clearWebEnrollmentStatusCache(enrollmentStatusCacheRef)
  }, [selectedTenant?.id, id, entityid, layoutid])

  return (
    <>
      {faxDocumentDetails?.isOpen &&
        (faxDocumentDetails.multipleDocument &&
        checkQueType(queueData) !== 'Letter' ? (
          <MultiUploadWrapper
            id={faxDocumentDetails?.document_id?.toString() ?? ''}
            element={faxDocumentDetails?.element ?? ({} as ElementType)}
            mode={MODE_CONSTANTS.EDIT}
            isOpenForListing={faxDocumentDetails?.isOpen}
            fullLayout={listingLayout as unknown as LayoutResponseType}
            entityName={entityName}
            fromQueueTable={true}
            setRenderMultiUpload={(valOrUpdater) => {
              const resolved =
                typeof valOrUpdater === 'function'
                  ? valOrUpdater({
                      isOpen: faxDocumentDetails.isOpen,
                      element: undefined,
                      id: faxDocumentDetails.document_id?.toString(),
                    })
                  : valOrUpdater
              if (!resolved.isOpen) {
                setFaxDocumentDetails((prev) => ({ ...prev, isOpen: false }))
              }
            }}
            customHeader={`${getHeaderForModal()} : ${
              faxDocumentDetails.faxName
            }`}
            onEditClick={() =>
              assignQueueToReviewerFunction(
                faxDocumentDetails.faxId,
                faxDocumentDetails.faxName,
                faxDocumentDetails.case_id,
                false,
                faxDocumentDetails?.selectedRow
              )
            }
            isEditButtonVisible={isEditButtonVisible()}
          />
        ) : (
          <FaxDocumentModal
            isOpen={faxDocumentDetails.isOpen}
            closeModal={() =>
              setFaxDocumentDetails({
                users_id: '-1',
                programs_id: '-1',
                isOpen: false,
                faxId: 0,
                faxName: '',
                communicationId: 0,
                case_id: '',
              })
            }
            faxId={faxDocumentDetails?.faxId}
            faxName={faxDocumentDetails?.faxName}
            handleReviewButtonClick={() =>
              assignQueueToReviewerFunction(
                faxDocumentDetails.faxId,
                faxDocumentDetails.faxName,
                faxDocumentDetails.case_id,
                false,
                faxDocumentDetails?.selectedRow
              )
            }
            communicationId={faxDocumentDetails?.communicationId}
            programs_id={faxDocumentDetails?.programs_id}
            users_id={faxDocumentDetails?.users_id}
            queueType={queueType}
            entity_name={entityName}
          />
        ))}
      <div className="flex flex-col gap-2 flex-1 overflow-y-auto overflow-hidden">
        {/*TODO: this 'quetable' class need to remove after demo */}
        <div
          className={`rounded-lg text-black flex flex-col h-[100%] quetable ${
            isDashboard ? '' : 'table-wrap'
          }`}
        >
          {!!listingLayout && (
            <PersistTable
              isPersistColumns={true}
              dataQaId="custom-table-manage-queue"
              tableName={`queue-${id}-${selectedTenant?.id}`}
              data={queueRowsData}
              isColumnChooser
              // columns={
              //   queueData?.entity_name?.toLowerCase() ===
              //   ENTITY_NAME.CASE_LOWER
              //     ? getTableHeadersFromLayoutForCase(listingLayout)
              //     : getTableHeadersFromLayout(
              //         listingLayout,
              //         queueData?.entity_name
              //       )
              // }
              actions={isReadOnlyUser() ? [] : getActionsProp(queueData)}
              columns={getTableHeadersFromLayout(
                isCaseWorkBasket || isTaskWorkBasket
              )}
              onSortClick={onSortClick}
              sort={
                sortDirection.key && !isEmpty(sortDirection?.key)
                  ? {
                      key: sortDirection?.key,
                      isAsc: sortDirection?.isAsc,
                    }
                  : null
              }
              showTableColumnOnEmpty
              onColumnClick={onColumnClick}
              onActionClick={onActionClick}
              disabledKey={'disabled'}
              emptyDataMessage={emptyDataMessage}
              onFilterChange={onFilterChange}
              filterObject={apiFilter}
              headerValues={headerValues}
              showRestoreButton={true}
              maxHeight={`${isDashboard ? '60rem' : ''}`}
              minHeight={`${isDashboard ? '20rem' : ''}`}
            />
          )}
          {entityData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalElements={totalElements}
              numberOfElements={numberOfElements}
              onPageChange={handlePageChange}
              onRowsChange={(rowsPerPage) => {
                dispatch(
                  updateNumOfRows({
                    numOfRows: rowsPerPage,
                    key: `queue-${queueData?.name}-${queueData?.id}-${selectedTenant?.id}`,
                  })
                )
              }}
              rowsPer={
                numOfPage?.[
                  `queue-${queueData?.name}-${queueData?.id}-${selectedTenant?.id}`
                ]
                  ? numOfPage[
                      `queue-${queueData?.name}-${queueData?.id}-${selectedTenant?.id}`
                    ]
                  : PAGINATION.ROWS_PER_PAGE
              }
            />
          )}
        </div>
        {modal.state && (
          <ConfirmDialog
            message={DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_UNASSIGN_MESSAGE}
            onCancel={() => setModal({ type: '', state: false, index: -1 })}
            onConfirm={
              modal.type ===
              DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_UNASSIGN_MESSAGE
                ? () => handleUnssignedClick(modal?.index ?? -1, modal?.row)
                : noop
            }
            open={
              modal.type ===
              DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_UNASSIGN_MESSAGE
            }
          />
        )}
      </div>
    </>
  )
}
